if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (!this.form) return;

      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitBtn = this.querySelector('[name="add"]');

      if (theme.settings.afterAtc !== 'no-js') {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }

    /**
     * Product form submit: paint loading → open drawer → fetch add → settle UI.
     * @param {SubmitEvent} evt
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
      if (!this.submitBtn || this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const quickAddDrawer = this.closest('quick-add-drawer');
      await theme.atc.openDrawerAfterPaint(this.cartDrawer, this.submitBtn, quickAddDrawer);

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', theme.atc.sectionIds(this.cartDrawer));

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const data = await response.json();

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }
        if (data.status) this.setErrorMsgState(error);
        if (!response.ok) throw new Error(response.status);

        theme.atc.vibrate();

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          theme.atc.updateCartIcon(data);
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          if (this.cartDrawer) {
            this.cartDrawer.renderContents(data, false);
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        }

        this.dispatchCartEvents(data);
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: this.errorMsg?.textContent }
        }));
        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        theme.atc.finishSubmitter(this.submitBtn);
      }
    }

    /**
     * @param {object} data - Cart add response JSON.
     */
    dispatchCartEvents(data) {
      fetch(`${theme.routes.cart}.js`)
        .then((cartResponse) => {
          if (!cartResponse.ok) throw new Error(cartResponse.status);
          return cartResponse.json();
        })
        .then((cartData) => {
          const lineItem = cartData.items.find((item) => item.variant_id === data.variant_id);
          if (!lineItem) return;

          if (lineItem.quantity > data.quantity) {
            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: cartData,
                variantId: data.variant_id,
                oldQuantity: lineItem.quantity - data.quantity,
                newQuantity: lineItem.quantity
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { cart: cartData, variantId: data.variant_id }
            }));
          }
        })
        .catch(() => {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: { variantId: data.variant_id }
          }));
        });
    }

    /** @deprecated Prefer theme.atc.updateCartIcon — kept for external callers. */
    static updateCartIcon(response) {
      theme.atc.updateCartIcon(response);
    }

    /**
     * @param {string|false} [error=false]
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
